import { Component, DestroyRef, HostBinding, inject, input, signal, TemplateRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';

export interface PanelConfig {
  title: string;
  noDefaultPadding?: boolean;
  noBorder?: boolean;
  desktopStyleOverrides?: { [klass: string]: any } | null | undefined;
  template: TemplateRef<unknown>;
}

export interface FullPanelConfig {
  noMobilePadding?: boolean;
}

@Component({
  selector: 'glxy-three-panel',
  imports: [CommonModule, MatTabGroup, MatTab, MatDrawerContent, MatDrawerContainer],
  templateUrl: './three-panel.component.html',
  styleUrls: ['./three-panel.component.scss'],
})
export class ThreePanelComponent {
  @HostBinding('class') class = 'glxy-galaxy-three-panel';

  leftPanelConfig = input.required<PanelConfig>();
  centerPanelConfig = input.required<PanelConfig>();
  rightPanelConfig = input.required<PanelConfig>();
  showRightPanel = input<boolean>(true);
  fullPanelConfig = input<FullPanelConfig>({});
  heightOffset = input<string>('0px');
  currentLayout = signal<'desktop' | 'tablet' | 'mobile'>('desktop');

  private destroyRef = inject(DestroyRef);

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
      .subscribe((result) => {
        if (result.breakpoints[Breakpoints.XSmall]) {
          this.currentLayout.set('mobile');
        } else if (result.breakpoints[Breakpoints.Small] || result.breakpoints[Breakpoints.Medium]) {
          this.currentLayout.set('tablet');
        } else {
          this.currentLayout.set('desktop');
        }
      });
  }
}
